$(function () {
	$('.pre-delete').on('click', function(){
		var $this = $(this);
		$this.fadeOut('medium');
		setTimeout(function() {
			$this.fadeIn('medium');
		}, 3000)
	}) 
 
});